import DOMPurify from 'isomorphic-dompurify'

/**
 * Sanitizes HTML string to prevent XSS attacks.
 * Allows safe HTML elements and attributes while stripping dangerous content.
 */
export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html)
}
